module.exports = __webpack_public_path__ + "static/media/access.57573fdb.png";